import React from 'react';
import { useSelector } from 'react-redux';
import { getGroupNetValue } from './utils/groupCalculation';

const GroupNetValue = React.memo(({ symbolId, side, positionList }) => {
    const symbol = useSelector((state) => state.updateSymbol.symbols?.[symbolId]);
    const value = getGroupNetValue(positionList, symbol, side);
    const formatAmount = (val) =>isNaN(val) ? "0.00" : Number(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2,});

    return <span>{formatAmount(value)}</span>;
});
// const GroupNetValue = React.memo(({ symbolId, side, positionList }) => {
//     const symbol = useSelector((state) => state.updateSymbol.symbols?.[symbolId]);
//     const contractSize = symbol?.contractSize ?? 100;

//     const formatAmount = (value) => {
//         if (isNaN(value)) return "0.00";
//         return Number(value).toLocaleString(undefined, {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//         });
//     };
//     const totalNetValue = useMemo(() => {
//         if (!symbol || (!symbol.bid && !symbol.ask)) return "0.00";
//         const price = (symbol.bid + symbol.ask) / 2; // use mid-price or define logic

//         let totalAmount = 0;

//         for (const pos of positionList) {
//             totalAmount += pos.side === 1 ? (pos.amount ?? 0) : -(pos.amount ?? 0);
//         }

//         const value = totalAmount * price * contractSize;
//         return isFinite(value) ? value.toFixed(2) : "0.00";
//     }, [symbol, positionList, contractSize]);


//     return <span>{formatAmount(totalNetValue)}</span>;
// });

export default GroupNetValue;
